import {
  ExamObservationModel,
  IExamObservationModel,
} from './ExamObservationModel';
import { ISyncModel, SyncModel } from '@common/models/SyncModel';

export interface IVisitExamResultObservationModel extends ISyncModel {
  visitExamResultObservationId: number;
  visitExamResultId: number;
  examObservationId: number;
  examObservation: IExamObservationModel;
}

export class VisitExamResultObservationModel
  extends SyncModel
  implements IVisitExamResultObservationModel
{
  visitExamResultObservationId: number;
  visitExamResultId: number;
  examObservationId: number;
  examObservation: ExamObservationModel;

  constructor(params: IVisitExamResultObservationModel) {
    super(params);
    this.visitExamResultObservationId = params.visitExamResultObservationId;
    this.visitExamResultId = params.visitExamResultId;
    this.examObservationId = params.examObservationId;
    this.examObservation = new ExamObservationModel(params.examObservation);
  }
}
